export default __webpack_public_path__ + "b690e4b15b451103108789f95711eaf5.png";